import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const fetchDisabilityDesignations = async () => {
  const { data } = await axios.get(RailsRoutes.api_v2_disability_designations_path());
  return data.data;
};

export default () => useQuery(['disabilityDesignations'], fetchDisabilityDesignations);
